"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SPACING_CLASSES = {
    "none": '',
    "no-horizontal": 'py-4',
    "normal": 'p-4'
};
const Modal = ({ show = true, children, onClose, spacing = 'normal', autoWidth = true, colorVariant = 'white', header, align = 'center' }) => {
    const isInside = (0, react_1.useRef)(false);
    const downInside = (0, react_1.useRef)(false);
    const handleBackgroundClick = () => {
        if (!downInside.current && !isInside.current)
            handleClose();
    };
    const handleClose = () => {
        if (onClose)
            onClose();
    };
    const spacingClass = SPACING_CLASSES[spacing];
    return ((0, jsx_runtime_1.jsx)("div", { children: show && ((0, jsx_runtime_1.jsx)("div", { style: {
                position: 'fixed',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 30,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }, 
            //onClick={(e) => {handleBackgroundClick(); e.stopPropagation(); }}
            onMouseDown: () => { downInside.current = isInside.current; }, onMouseUp: handleBackgroundClick, children: (0, jsx_runtime_1.jsx)("div", { onClick: (e) => e.stopPropagation(), onMouseEnter: () => {
                    isInside.current = true;
                }, onMouseLeave: () => {
                    isInside.current = false;
                }, style: align === 'top' ? { height: 400 } : { maxHeight: '100%' }, children: (0, jsx_runtime_1.jsx)("div", { className: `card shadow bg-${colorVariant} overflow-hidden`, style: autoWidth ? { width: '100vw', maxWidth: 600, maxHeight: '100%' } : { maxHeight: '100%' }, children: (0, jsx_runtime_1.jsxs)("div", { className: `d-flex flex-column overflow-auto `, style: { maxHeight: '100%' }, children: [onClose && ((0, jsx_runtime_1.jsx)("a", { onClick: (e) => {
                                    e.preventDefault();
                                    handleClose();
                                }, href: "/", className: "p-2 link-dark fs-3 text-decoration-none lh-1", style: { position: 'absolute', right: 0, top: 0 }, children: (0, jsx_runtime_1.jsx)("span", { className: "px-1", children: "\u00D7" }) })), header && ((0, jsx_runtime_1.jsx)("div", { className: `${spacingClass}`, children: header })), (0, jsx_runtime_1.jsx)("div", { className: `flex-shrink-1 overflow-auto ${spacingClass} ${header ? 'pt-0' : ''}`, children: children })] }) }) }) })) }));
};
exports.Modal = Modal;
